const VALID_VARIANTS = ['pulse_player', 'pulse_header', 'pulse_tile'];

export { VALID_VARIANTS as default };
